import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as CommentSvg } from './assets/comment.svg';

const CommentIcon = React.forwardRef((args, ref) => <SvgIcon component={CommentSvg} ref={ref} {...args} />);

export default CommentIcon;
